/** Venda na rota — utilidades puras da tela do celular. */

/** − / + do celular: soma ou tira 1 da quantidade digitada (nunca abaixo de 1). */
export function stepQuantity(q: string, delta: 1 | -1): string {
  const n = Number(q.trim().replace(",", "."));
  if (!Number.isFinite(n) || n <= 0) return delta > 0 ? "1" : q;
  const next = Math.max(1, Math.round((n + delta) * 10_000) / 10_000);
  return next.toLocaleString("pt-BR", { maximumFractionDigits: 4, useGrouping: false });
}
